export default function (date, format = 'DD.MM.YYYY') {
    return moment(date).format(format);
}
